// import {useSelector} from 'react-redux';
// import {IS_AI_AGENT_FAB_ENABLED} from '../constants/floatingButtons';
// import type {TState} from '../redux/store.type';

/**
 * Whether the AI agent FAB occupies the bottom corner for the current user.
 * Master users only for now — a deliberate narrowing while the agent rolls out. The
 * endpoint itself enforces 'manage package', so widening this later is a client-side
 * change only; drop the isMaster term and check that role instead.
 */
function useIsAiAgentFabRendered(): boolean {
    // return useSelector((s: TState) => Boolean(
    //     IS_AI_AGENT_FAB_ENABLED
    //     && s.auth?.isLoggedIn
    //     && s.user?.isMaster,
    // ));
    return false;
}

export default useIsAiAgentFabRendered;
